
import LeftSearch from './components/LeftSearch'
import ChartContainer from './components/ChartContainer'
import Header from './components/Header'
import AppContext from './components/AppContext'
import { setProvider } from './visualization/povider'
import React, { useState } from 'react';
import "./App.css";

setProvider()

function App() {

  const setEsError = (isEsError) => {
    setDataState({ esError: isEsError, ...dataState })
  }

  const [dataState, setDataState] = useState({
    setEsError,
    esError: false,
  });

  return (
    <AppContext.Provider value={dataState}>
      <div className="d-flex flex-column h-100vh">
        <Header />
        <div className="d-flex flex-row w-100 flex-grow-1">
        <LeftSearch />
        <ChartContainer />
        </div>
        
      </div>
    </AppContext.Provider>
  );
}
export default App;
